'use strict';

import modalDirective from 'brg/rest/buttons/modal';
import resolveUsers from 'utils/resolve/users';

import addTemplate from './add.html';

export default modalDirective({
	template: addTemplate,
	controller: controller,
	resolve: {
		users: resolveUsers,
	}
});


function controller($scope, $http, $filter) {
	'ngInject';

	$scope.selectedDesignationID = $scope.$context.defaultDesignationID;
	$scope.datePopupOptions = {
		showWeeks: false,
	};
	$scope.designationPhones = {};
	$scope.$context.designations.forEach((d) => {
		$scope.designationPhones[d.uuid] = d.shared_phone_number;
	});

	let submitting = false;
	$scope.errors = null;

	$scope.submitData = function() {
		if (submitting) return;
		submitting = true;

		// Base data
		const data = {
			user: $scope.selectedUser.uuid,
			designation: $scope.selectedDesignationID,
			tzstr: $scope.$context.tz,
		};

		// Buid date effective
		switch ($scope.startType) {
			case 0:
				break;
			case 1:
				data.date_start = $filter('date')($scope.dateStart, 'yyyy-MM-dd');
				data.time_start = $filter('date')($scope.timeStart, 'HH:mm:') + '00';
				break;
		}
		
		// Build date through
		if ($scope.dateEnd && $scope.timeEnd) {
				data.date_end = $filter('date')($scope.dateEnd, 'yyyy-MM-dd');
				data.time_end = $filter('date')($scope.timeEnd, 'HH:mm:') + '00';
		}

		// Build phone number
		switch ($scope.phoneType) {
			case 0:
				data.phone_number = $scope.designationPhones[$scope.selectedDesignationID];
				break;
			case 1:
				data.phone_number = $scope.selectedUser.phone_number;
				break;
			case 2:
				data.phone_number = $scope.customPhoneNumber;
				break;
		}

		$http({
			method: 'POST',
			url: '/api/entities/admin/v2/schedule_designation_profile',
			data: data,
		}).then((response) => {
			$scope.$close(response.data);
		}, (error) => {
			console.error(error);
			$scope.errors = error.data;
		}).finally(() => {
			submitting = false;
		});
	}
}
